import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import { SUBMIT_BASE_PRICE, VOTE_BASE_PRICE } from "..";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function Faq({ id }) {
  
  const FAQ_LIST = [
    {
      question: "How many times can I submit?",
      answer: "You can submit up to 5 farts per championship. Make them count!",
    },
    {
      question: "Can I vote on my own fart?",
      answer: "Yes, but it'll cost you like everyone else 💸. No favoritism here!",
    },
    {
      question: "How are winners chosen?",
      answer: "The farts with the most votes win! The leaderboard updates live.",
    },
    {
      question: "How do I earn as a voter?",
      answer:
        "When a fart wins 1st, 2nd, or 3rd place, 30% of that fart's prize is distributed evenly among everyone who voted for it. " +
        "So if you vote for a top-ranking fart, you earn FLART as a reward — the earlier and smarter you vote, the better your odds! " +
        "Note: your voting fee contributes to the total prize pool, helping make rewards possible.",
    },
    {
      question: "How are prices calculated?",
      answer: `Prices are based on the following reference SOL prices:

  - 🧻 Submission Fee: ${SUBMIT_BASE_PRICE} SOL
  - 🗳️ Vote Fee: ${VOTE_BASE_PRICE} SOL

  These values are fixed in SOL, and when you take action (submit or vote), they're converted to FLART based on the current exchange rate.

  This ensures fairness even if the FLART price changes. So you're always paying the same value in SOL.`,
    },
    {
      question: "How is the prize pool distributed?",
      answer: `
The prize pool is built from all submission and vote fees. Here's how it's distributed:

- 🧾 **10%** goes to the platform as commission.
- 🔥 **5%** is burned to reduce token supply.
- 🏆 The rest goes to the **top 3 farts**:
  - 🥇 First Place: 60%
  - 🥈 Second Place: 25%
  - 🥉 Third Place: 10%

Each of these prizes is then split between:
- 🎨 **70% to the fart creator**
- 🗳️ **30% to the voters** (evenly divided among all who voted on that fart)

After the championship, the rewards are calculated and distributed to all the winners.`.trim(),
    },
    {
      question: "What happens after the championship ends?",
      answer:
        "Winners are announced, prizes are distributed, and a new championship begins soon after. Stay stinky! 💨",
    },
  ];


  return (
    <Box
      id={ id }
      sx={{
        my: 10,
        px: { xs: 2, md: 10 },
        py: 10,
        backgroundColor: "#fff9c4",
        borderTop: "5px dashed #FFD700",
        borderBottom: "5px dashed #FFD700",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          textAlign: "center",
          mb: 4,
          fontWeight: "bold",
          color: "#FF4E50",
          textShadow: "2px 2px 0 rgba(0,0,0,0.2)",
        }}
      >
        🤔 Frequently Asked Farts (FAQ)
      </Typography>

      {FAQ_LIST.map((item, index) => {
        return (
          <Accordion
            key={index}
            disableGutters
            elevation={0}
            square={false}
            sx={{
              overflow: "hidden",
              mb: 2,
              backgroundColor: "#ffffff",
              border: "2px solid #FFD700",
              boxShadow: "4px 4px 0 rgba(0,0,0,0.2)",
              borderTopLeftRadius: "16px !important",
              borderTopRightRadius: "16px !important",
              borderBottomLeftRadius: "16px !important",
              borderBottomRightRadius: "16px !important",
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#FF4E50" }} />}
              sx={{
                backgroundColor: "#fff3cd",
                padding: "12px 16px",
                fontWeight: "bold",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  color: "#444",
                  textShadow: "1px 1px 0 #fff",
                }}
              >
                {item.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                backgroundColor: "#fffef5",
                color: "#333",
                fontSize: "1rem",
                lineHeight: 1.6,
                padding: "16px 24px",
                borderTop: "1px dashed #FFD700",
                whiteSpace: "pre-wrap",
              }}
            >
              <Typography>{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
}

export default Faq;
